import React, { useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { Text, Flex, Button, Divider } from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import { useShipmentForm } from "context/DHLShipmentFormContext";
import TextInput from "./components/TextInput";

const ShipmentDate = () => {
  const [value, setValue] = useState("");
  const navigate = useNavigate();
  const { formData, updateFormData } = useShipmentForm();

  const validationSchema = Yup.object({
    dateAndTime: Yup.date().required("Date is required*"),
  });

  const initialValues = {
    dateAndTime: formData?.dateAndTime,
  };

  const today = new Date();
  const minDate = new Date(today);
  // minDate.setDate(today.getDate(); // Start from tomorrow
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 6); // Allow until 7 days from today

  const formatDate = (date) => date.toISOString().split("T")[0]; // yyyy-mm-dd

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          // justifyContent={"space-between"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              updateFormData({ dateAndTime: values?.dateAndTime });
              navigate("/send-a-bag/dhl/pickup");
            }}
          >
            {(formik) => (
              <Form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  height: "100%",
                }}
              >
                <Flex flexDirection={"column"} gap={4} flex={1}>
                  <Text
                    fontFamily={"PlusJakartaSansSemiBold"}
                    fontSize={"16px"}
                    lineHeight={"20px"}
                    textTransform={"capitalize"}
                    color={"#000000"}
                  >
                    I’m sending my shipment on
                  </Text>
                  <TextInput
                    formik={formik}
                    name="dateAndTime"
                    label={"Select Date"}
                    placeholder={"Select a Date"}
                    type="date"
                    min={formatDate(minDate)}
                    max={formatDate(maxDate)}
                  />
                  {/* <Flex
                      gap={4}
                      marginTop={2}
                      borderWidth={"1px"}
                      borderColor={"#D9D9D9"}
                      borderStyle={"solid"}
                      padding={4}
                      borderRadius={"6px"}
                      flexDirection={"column"}
                    >
                      <Box
                        border="1px solid"
                        borderColor={value === "12:00" ? "#456EFF" : "gray.300"}
                        bg={value === "12:00" ? "#456EFF0D" : "white"}
                        borderRadius="4px"
                        p="4"
                        cursor="pointer"
                        onClick={() => setValue("12:00")}
                      >
                        <Flex align="center" justifyContent={"space-between"}>
                          <Box>
                            <Text
                              fontSize={"12px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#000000"}
                            >
                              April 25
                            </Text>
                            <Text
                              fontSize={"12px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#898989"}
                              mt={1}
                            >
                              12/23/24
                            </Text>
                          </Box>
                          <Box>
                            <Text
                              fontSize={"16px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#000000"}
                            >
                              12:00 PM
                            </Text>
                          </Box>
                          <Box>
                            <Text
                              fontSize={"12px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#898989"}
                            >
                              Express Domestic 12:00
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                      <Box
                        border="1px solid"
                        borderColor={
                          value === "12:00am" ? "#456EFF" : "gray.300"
                        }
                        bg={value === "12:00am" ? "#456EFF0D" : "white"}
                        borderRadius="4px"
                        p="4"
                        cursor="pointer"
                        onClick={() => setValue("12:00am")}
                      >
                        <Flex align="center" justifyContent={"space-between"}>
                          <Box>
                            <Text
                              fontSize={"12px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#000000"}
                            >
                              April 25
                            </Text>
                            <Text
                              fontSize={"12px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#898989"}
                              mt={1}
                            >
                              12/23/24
                            </Text>
                          </Box>
                          <Box>
                            <Text
                              fontSize={"16px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#000000"}
                            >
                              12:00 PM
                            </Text>
                          </Box>
                          <Box>
                            <Text
                              fontSize={"12px"}
                              fontFamily={"PlusJakartaSansRegular"}
                              color={"#898989"}
                            >
                              Express Domestic
                            </Text>
                          </Box>
                        </Flex>
                      </Box>
                    </Flex> */}
                </Flex>
                <Flex mt={4} gap={2}>
                  <Flex>
                    <Button
                      onClick={() => navigate(-1)}
                      width={"148px"}
                      borderRadius={8}
                      bg={"none"}
                      border={"1px solid #000000"}
                      color={"#000000"}
                      fontSize={"12px"}
                      fontWeight={"500"}
                      fontFamily={"PlusJakartaSansMedium"}
                      letterSpacing={0.2}
                    >
                      Back
                    </Button>
                  </Flex>
                  <Flex justifyContent={"flex-end"} w={"100%"}>
                    <Button
                      onClick={() => formik.handleSubmit()}
                      flex={1}
                      maxW={"148px"}
                      background={"#000000"}
                      color={"#FFFFFF"}
                      borderRadius={8}
                      fontSize={"12px"}
                      fontFamily={"PlusJakartaSansMedium"}
                      textTransform={"uppercase"}
                      // isDisabled={}
                      _disabled={{
                        bg: "grey.100",
                        cursor: "default",
                        _hover: {
                          bg: "grey.100",
                          cursor: "default",
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export default ShipmentDate;
